if (!window.__addInitialized) {

  window.__addInitialized = true;

  document.addEventListener('click', async function(e){

    // PLUS
    if (e.target.classList.contains('__add_plus')) {

      e.preventDefault();

      const input = e.target
        .closest('.__add_qty_wrapper')
        .querySelector('.__add_qty_input');

      input.value = parseInt(input.value || 1) + 1;
    }

    // MINUS
    if (e.target.classList.contains('__add_minus')) {

      e.preventDefault();

      const input = e.target
        .closest('.__add_qty_wrapper')
        .querySelector('.__add_qty_input');

      const qty = parseInt(input.value || 1);

      if (qty > 1) {
        input.value = qty - 1;
      }
    }

    // ADD TO CART
    if (e.target.classList.contains('__add_cart_btn')) {

      e.preventDefault();

      const button = e.target;

      if (button.classList.contains('__add_loading')) {
        return;
      }

      button.classList.add('__add_loading');

      const wrapper = button.closest('.__add_wrapper');

      const qtyInput = wrapper.querySelector('.__add_qty_input');

      const quantity = parseInt(qtyInput.value || 1);

      const variantId = button.dataset.variantId;

      button.disabled = true;
      button.innerText = 'ADDING...';

      try {

        // ADD PRODUCT
        const response = await fetch('/cart/add.js', {
          method:'POST',
          headers:{
            'Content-Type':'application/json'
          },
          body:JSON.stringify({
            id: variantId,
            quantity: quantity
          })
        });

        if (response.ok) {

          // UPDATED CART
          const cartResponse = await fetch('/cart.js');
          const cart = await cartResponse.json();

          // UPDATED SECTIONS
          const sectionsResponse = await fetch(
            `${window.Shopify.routes.root}?sections=cart-drawer,cart-icon-bubble`
          );

          const sections = await sectionsResponse.json();

          // HORIZON CART EVENT
          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles:true,
              detail:{
                resource:cart,
                sourceId:'__add_additional_cart',
                data:{
                  source:'__add_additional_cart',
                  productId:variantId,
                  variantId:variantId,
                  itemCount:cart.item_count,
                  sections:sections
                }
              }
            })
          );

          // UPDATE DRAWER
          const currentDrawer = document.querySelector(
            'cart-drawer-component'
          );

          if (
            currentDrawer &&
            sections['cart-drawer']
          ) {

            const parser = new DOMParser();

            const doc = parser.parseFromString(
              sections['cart-drawer'],
              'text/html'
            );

            const newDrawer = doc.querySelector(
              'cart-drawer-component'
            );

            if (newDrawer) {
              currentDrawer.replaceWith(newDrawer);
            }

          }

          // UPDATE BUBBLE
          const currentBubble = document.querySelector(
            '#shopify-section-cart-icon-bubble'
          );

          if (
            currentBubble &&
            sections['cart-icon-bubble']
          ) {

            const parser = new DOMParser();

            const doc = parser.parseFromString(
              sections['cart-icon-bubble'],
              'text/html'
            );

            const newBubble = doc.querySelector(
              '#shopify-section-cart-icon-bubble'
            );

            if (newBubble) {
              currentBubble.replaceWith(newBubble);
            }

          }

          // OPEN DRAWER
          const updatedDrawer = document.querySelector(
            'cart-drawer-component'
          );

          if (
            updatedDrawer &&
            typeof updatedDrawer.open === 'function'
          ) {
            updatedDrawer.open();
          }

          button.innerText = 'ADDED ✓';

        } else {

          button.innerText = 'ERROR';

        }

      } catch(error){

        console.error(error);

        button.innerText = 'ERROR';

      }

      setTimeout(() => {

        button.innerText = 'ADD TO CART';

        button.disabled = false;

        button.classList.remove('__add_loading');

      },1500);

    }

  });

}